/**
 * Example
 */

const paramControl = {
    log(msg) {
        /* eslint-disable */
        console.log(msg)
        /* eslint-enable */
    },

    isInternal(url) {
        const base = new URL(`${window.location.protocol}//${window.location.host}`);
        return new URL(url, base).hostname === base.hostname;
    },

    init() {
        window.addEventListener('load', () => {
            const links = [...document.querySelectorAll('a')];
            if (links) {
                links.forEach((link) => {
                    // eslint-disable-next-line
                    let url = link.getAttribute('href');
                    // eslint-disable-next-line
                    let params = new URLSearchParams(url.search);
                    const isInternal = this.isInternal(url);
                    // eslint-disable-next-line
                    console.log(params);

                    if (isInternal) {
                        params.set('ignore-lang', '1');
                        link.search = params.toString();
                        // eslint-disable-next-line
                        console.log(url);
                    }
                });
            }
        });
        // const links = document.querySelectorAll('a');

        // window.location.search = params;
    }
};

export default paramControl;



// WEBPACK FOOTER //
// ./___src/assets/js/scripts/paramControl.js